import cardTemplate from './card.html?raw';

export class Card extends HTMLElement {
    constructor() {
        super();
    }

    static get observedAttributes() {
        return ['shadow', 'radius', 'blue', 'border-dark'];
    }

    connectedCallback() {
        this.render();
    }

    attributeChangedCallback(_, oldValue, newValue) {
        if (oldValue === newValue) return;
        this.render();
    }
    get card() {
        return this.shadowRoot.querySelector('.card');
    }

    render() {
        this.clearPreviousRender();
        this.createHtmlTemplate();
        this.addClasses();
        this.appendSlots();
    }

    clearPreviousRender() {
        if (!this.shadowRoot) {
            this.attachShadow({ mode: 'open' });
        } else {
            this.shadowRoot.innerHTML = '';
        }
    }

    createHtmlTemplate() {
        const template = document.createElement('template');
        template.innerHTML = cardTemplate;
        this.shadowRoot.appendChild(template.content.cloneNode(true));
    }

    addClasses() {
        this.addClass('radius');
        this.addClass('shadow');
        this.addClassByBoolProperty('blue');
        this.addClassByBoolProperty('border-dark');
    }

    addClass(prop) {
        if (!this.hasAttribute(prop)) return;
        this.card.classList.add(`${prop}-${this.getAttribute(prop)}`);
    }

    addClassByBoolProperty(prop) {
        if (!this.hasAttribute(prop)) return;
        this.card.classList.add(prop);
    }

    appendSlots() {
        this.appendSlot('header');
        this.appendSlot();
        this.appendSlot('footer');
    }

    appendSlot(name) {
        var slots = this.getSlots(name);
        slots.forEach((el) => {
            const slot = document.createElement('slot');
            slot.name = el.slot;
            this.card.appendChild(slot);
        });
    }

    getSlots = (name) =>
        Array.from(this.children).filter(
            (el) =>
                el.nodeType === 1 && el.hasAttribute('slot') && el.name === name
        );
}

customElements.define('svea-card', Card);
